import { ReactComponent as ExportIcon } from 'assets/svg/export.svg';
import { ReactComponent as ImportIcon } from 'assets/svg/import.svg';
import { paginationOptions } from 'src/utils/constants';
export const LEADS_STATUS = {
  raw: {
    label: 'Raw',
    value: 'raw',
    color: 'red',
  },
  cleaned: {
    label: 'Cleaned',
    value: 'cleaned',
    color: 'red',
  },
  normalized: {
    label: 'Normalized',
    value: 'normalized',
    color: 'red',
  },
  enriched: {
    label: 'Enriched',
    value: 'enriched',
    color: 'red',
  },
  approved: {
    label: 'Approved',
    value: 'approved',
    color: 'red',
  },
  unnormalized: {
    label: 'Not Normalized',
    value: 'unnormalized',
    color: 'red',
  },
  uncleaned: {
    label: 'Not Cleaned',
    value: 'uncleaned',
    color: 'red',
  },
  unenriched: {
    label: 'Not Enriched',
    value: 'unenriched',
    color: 'red',
  },
  unapproved: {
    label: 'Not Approved',
    value: 'unapproved',
    color: 'red',
  },
  assigned_to_me: {
    label: 'Assigned to me',
    value: 'assigned_to_me',
    color: 'red',
    me: true,
  },
  attention_required: {
    label: 'Attention Required',
    value: 'attention_required',
    color: 'red',
  },
  normalized_by_me: {
    label: 'Normalized by me',
    value: 'normalized_by_me',
    color: 'red',
    me: true,
  },
  cleaned_by_me: {
    label: 'Cleaned by me',
    value: 'cleaned_by_me',
    color: 'red',
    me: true,
  },
  enriched_by_me: {
    label: 'Enriched by me',
    value: 'enriched_by_me',
    color: 'red',
    me: true,
  },
  approved_by_me: {
    label: 'Approved by me',
    value: 'approved_by_me',
    color: 'red',
    me: true,
  },
};

export const SORT_ITEMS = [
  { label: 'Newest to Oldest', value: { sortBy: 'added', orderBy: 'desc' } },
  { label: 'Oldest to Newest', value: { sortBy: 'added', orderBy: 'asc' } },
  { label: 'Last Modified', value: { sortBy: 'lastModified', orderBy: 'desc' } },
];

export const FILTER_TYPES = {
  All_FILTERS: 'filters',
  SAVED_FILTERS: 'savedFilters',
};

export const ORDER_FILTER = {
  orderBy: 'added',
  orderType: 'desc',
};

export const COUNTRIES = [
  {
    label: 'United States',
    value: 'US',
    image: 'https://signalassets.blob.core.windows.net/signal/assets/usflag.png',
  },
  {
    label: 'Canada',
    value: 'CA',
    image: 'https://signalassets.blob.core.windows.net/signal/assets/canadaflag.png',
  },
];

export const LEADS_STATUS_OPTIONS = Object.values(LEADS_STATUS);

export const STAR_RATING = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const DATE_RANGE_OPTIONS = [
  {
    label: 'Added to System',
    value: 'added_to_System',
  },
  {
    label: 'Modified',
    value: 'modified',
  },
  {
    label: 'Status Change',
    value: 'status_change',
  },
];

export const BUILDING_CLASS = [
  { label: 'A', value: 'a' },
  { label: 'B', value: 'b' },
  { label: 'C', value: 'c' },
  { label: 'D', value: 'd' },
  { label: 'E', value: 'e' },
  { label: 'F', value: 'f' },
];

export const TENANCY_STATUS = {
  single: {
    label: 'Single',
    value: 'single',
  },
  multi: {
    label: 'Multi',
    value: 'multi',
  },
};

export const ENRICHED_BY = {
  zoomInfo: {
    label: 'ZoomInfo',
    value: 'zoomInfo',
  },
  apollo: {
    label: 'Apollo',
    value: 'apollo',
  },
  undetermined: {
    label: 'No Source',
    value: 'undetermined',
  },
};

export const INDUSTRY_VERTICALS = {
  commercial: {
    label: 'Commercial',
    value: 'commercial',
  },
  industrial: {
    label: 'Industrial',
    value: 'industrial',
  },
  distribution: {
    label: 'Distribution',
    value: 'distribution',
  },
  manufacturing: {
    label: 'Manufacturing',
    value: 'manufacturing',
  },
  residential: {
    label: 'Residential',
    value: 'residential',
  },
  missing: {
    label: 'No Primary Vertical',
    value: 'missing',
  },
};

export const PROPERTY_AFFILIATION = [
  {
    label: 'Tenant',
    value: 'tenant',
  },
  {
    label: 'Owned',
    value: 'owned',
  },
  {
    label: 'Shared',
    value: 'shared',
  },
  {
    label: 'Managed',
    value: 'managed',
  },
  {
    label: 'Headquarters',
    value: 'headquarters',
  },
  {
    label: 'Regional Office',
    value: 'regional_office',
  },
];
export const OWNER_AFFILIATION = [
  {
    label: 'Decision Maker',
    value: 'decision_maker',
  },
  {
    label: 'End User',
    value: 'end_user',
  },
  {
    label: 'Billing',
    value: 'billing',
  },
  {
    label: 'Blocker',
    value: 'blocker',
  },
  {
    label: 'Influencer',
    value: 'influencer',
  },
];

export const TENANCY_STATUS_OPTIONS = Object.values(TENANCY_STATUS);
export const INDUSTRY_VERTICALS_OPTIONS = Object.values(INDUSTRY_VERTICALS);
export const ENRICHED_BY_OPTIONS = Object.values(ENRICHED_BY);

export const FILTER_LABEL_MAP = {
  country: 'Country',
  states: 'States',
  leadStatuses: 'Lead Status',
  cities: 'City',
  zipCodes: 'Zip Codes',
  starRatings: 'Star Rating',
  dateFilter: 'Date Filter',
  dateRange: 'Date Range',
  tenancies: 'Tenancy',
  buildingClasses: 'Building Class',
  industryVerticals: 'Industry Verticals',
  primaryVerticals: 'Primary Vertical',
  enrichedBies: 'Dominant Enrichment Source',
};

export const ACTIVITY_LOGS_TYPE = {
  all: { label: 'All logs', value: 'all' },
  system: { label: 'System logs', value: 'System' },
  user: { label: 'User logs', value: 'User' },
};

export const ACTIVITY_LOGS_TYPE_OPTIONS = Object.values(ACTIVITY_LOGS_TYPE);

export const DEFAULT_FILTER = {
  country: COUNTRIES[0],
  filterId: '',
};

export const DEFAULT_QUERY_PARAMS = {
  page: 1,
  perPage: paginationOptions.perPageRows,
  sortBy: 'added',
  orderBy: 'desc',
  search: '',
  assignedTo: [],
};

export const LEAD_COLUMNS_COMMON = (t) => [
  {
    id: 'propertyName',
    label: t('leads.listing.propertyName'),
    sortable: true,
  },
  { id: 'address', label: t('leads.listing.address'), sortable: true },
  { id: 'country', label: t('leads.listing.country'), sortable: true },
  { id: 'county', label: t('leads.listing.county'), sortable: true },
  { id: 'state', label: t('leads.listing.state'), sortable: true },
  { id: 'city', label: t('leads.listing.city'), sortable: true },
  { id: 'zipCode', label: t('leads.listing.zipcode'), sortable: true },
  { id: 'buildingStatus', label: t('leads.listing.buildingStatus'), sortable: true },
  { id: 'status', label: t('leads.listing.status'), sortable: true },
  { id: 'assignedTo', label: t('leads.listing.assignedTo'), sortable: true },
  { id: 'processedBy', label: t('leads.listing.processedBy'), sortable: true },
  { id: 'lotNumber', label: t('leads.listing.lotNumber'), sortable: true },
  { id: 'primaryVertical', label: t('leads.listing.primaryVertical'), sortable: true },
  { id: 'added', label: t('leads.listing.added'), sortable: true },
  { id: 'addedBy', label: t('leads.listing.addedBy'), sortable: true },
  { id: 'lastModified', label: t('leads.listing.lastModified'), sortable: true },
  { id: 'lastModifiedBy', label: t('leads.listing.lastModifiedBy'), sortable: true },
  { id: 'dataSource', label: t('leads.listing.dataSource'), sortable: true },
  { id: 'dataType', label: t('leads.listing.dataType'), sortable: true },
  { id: 'tenancy', label: t('leads.listing.tenancy'), sortable: true },
  { id: 'landArea', label: t('leads.listing.landArea'), sortable: true },
  { id: 'amenities', label: t('leads.listing.amenities'), sortable: true },
  { id: 'rba', label: t('leads.listing.rba'), sortable: true },
  { id: 'numberOfLoadingDocks', label: t('leads.listing.noOfLoadingDocks'), sortable: true },
  { id: 'numberOfParkingSpaces', label: t('leads.listing.noOfParkingSpaces'), sortable: true },
];

export const LEAD_COLUMNS = (t) => [
  ...LEAD_COLUMNS_COMMON(t),
  { id: 'isBeingValidated', label: t('leads.listing.validation'), sortable: true },
];

export const LEAD_COLUMNS_ARCHIVED = (t) => [
  ...LEAD_COLUMNS_COMMON(t),
  { id: 'deletedAt', label: t('leads.listing.deletedAt'), sortable: true },
  { id: 'deletedBy', label: t('leads.listing.deletedBy'), sortable: true },
];

export const ARCHIVED_FILTER = (t) => [
  { label: t('leads.general.all'), value: null },
  { label: t('leads.general.rawData'), value: 'raw' },
  { label: t('leads.general.cleaned'), value: 'cleaned' },
  { label: t('leads.general.enriched'), value: 'enriched' },
  { label: t('leads.general.approved'), value: 'approved' },
];

export const BUILDING_STATUS_OPTIONS = [
  {
    label: 'Existing',
    value: 'existing',
  },
];

export const DEFAULT_COLUMNS = [
  'propertyName',
  'address',
  'country',
  'county',
  'state',
  'city',
  'zipCode',
  'status',
  'isBeingValidated',
  'assignedTo',
  'processedBy',
  'lotNumber',
  'primaryVertical',
  'added',
  'addedBy',
  'lastModified',
  'lastModifiedBy',
  'dataSource',
  'dataType',
  'tenancy',
  'landArea',
  'rba',
  'buildingStatus',
  'numberOfLoadingDocks',
  'numberOfParkingSpaces',
  'amenities',
];

export const USER_COLUMNS_PREFERENCE = (t) =>
  LEAD_COLUMNS(t).map((col, index) => ({
    visible: DEFAULT_COLUMNS.includes(col.id),
    columnName: col.id,
    position: index + 1,
  }));

export const FILTERS_OPTIONS_MAP = {
  country: COUNTRIES,
  leadStatus: LEADS_STATUS_OPTIONS,
  starRating: STAR_RATING,
  dateFilters: DATE_RANGE_OPTIONS,
  tenancy: TENANCY_STATUS_OPTIONS,
  buildingClass: BUILDING_CLASS,
  buildingStatus: BUILDING_STATUS_OPTIONS,
  propertyAffiliation: PROPERTY_AFFILIATION,
  ownerAffiliation: OWNER_AFFILIATION,
  industryVerticals: INDUSTRY_VERTICALS_OPTIONS,
  primaryVerticals: INDUSTRY_VERTICALS_OPTIONS,
  enrichedBies: ENRICHED_BY_OPTIONS,
};

export const findItemByValue = (name, value) => {
  return FILTERS_OPTIONS_MAP?.[name]?.find((item) => item.value == value) || {};
};

export const STAGES = {
  raw: {
    label: 'Raw Data',
    step: 0,
    value: 'raw',
    action: {
      label: 'Mark as Normalized',
      value: 'normalized',
    },
  },
  normalized: {
    label: 'Raw Data',
    step: 0,
    value: 'raw',
    hide: true,
    action: {
      label: 'Mark as Cleaned',
      value: 'cleaned',
    },
  },
  cleaned: {
    label: 'Cleaned',
    step: 1,
    value: 'cleaned',
    action: {
      label: 'Mark as Enriched',
      value: 'enriched',
    },
  },
  enriched: {
    label: 'Enriched',
    step: 2,
    value: 'enriched',
    action: {
      label: 'Mark as Approved',
      value: 'approved',
    },
  },
  approved: { label: 'Approved', step: 4, value: 'approved' },
};

export const STATUS_DESCRIPTION = {
  unnormalized:
    'This lead requires attention! Some fields could not be normalized by the system. Manual normalization is required.',
  uncleaned:
    'This lead requires attention! Some fields could not be cleaned by the system. Manual cleaning is required.',
  unenriched:
    'This lead requires attention! Some fields could not be enriched by the system. Manual enrichment is required.',
  unapproved:
    'This lead requires attention! Some fields could not be validated by the system. Manual validation is required.',
};

export const STAGES_OPTIONS = Object.values(STAGES);

export const EXPORT_OPTIONS = [
  { label: 'Export to Hubspot', value: 'hubspot', icon: <ExportIcon /> },
  { label: 'Export as .CSV', value: 'csv', icon: <ImportIcon /> },
];
